import { Services } from "appworks/services/services";
import { AutoplayService } from "slotworks/services/autoplay/autoplay-service";
import { ButtonControl } from "./button-control";

export class AutoStopControl extends ButtonControl {
    protected onClick(): void {
        Services.get(AutoplayService).stop();
    }
}
